import {PayloadAction, createSlice} from '@reduxjs/toolkit';
import {countriesInitialState} from './data';
import {Country} from './types';

const countriesSlice = createSlice({
  name: 'countries',
  initialState: countriesInitialState,
  reducers: {
    countriesFetchStarted: state => {
      state.countriesLoading = true;
    },
    countriesFetchSucceeded: (state, {payload}: PayloadAction<Country[]>) => {
      state.list = payload;
      state.countriesLoading = false;
    },
    countriesFetchFailed: state => {
      state.list = [];
      state.countriesLoading = false;
    },
    receivedCountryCurrencies: (state, {payload}: PayloadAction<string[]>) => {
      state.currencies = payload;
    },
    deleteFromCountries: (state, {payload}: PayloadAction<{id: string}>) => {
      state.list = (state.list ?? []).filter(
        country => payload.id !== country.id
      );
    }
  }
});

export const {
  countriesFetchStarted,
  countriesFetchSucceeded,
  countriesFetchFailed,
  receivedCountryCurrencies,
  deleteFromCountries
} = countriesSlice.actions;

export default countriesSlice.reducer;
